import React, { useEffect } from 'react';
import styled from 'styled-components';
import Imgix from 'react-imgix';
import { getImgixUrl } from '../../../../utils/helper';

const Wrapper = styled.div`
  cursor: pointer;
  position: relative;
  border: ${({ selected }) =>
    selected ? '3px solid #a83569' : '3px solid white'};
  border-radius: 3px;
  padding: 1px;
  .selected-icon {
    top: 2px;
    right: 2px;
    position: absolute;
  }
  .fabric-image-filter {
    width: 100%;
    height: auto;
  }
`;

function FabricItem({
  image,
  name,
  selected,
  onClick,
}) {
  return (
    <Wrapper onClick={onClick} selected={selected}>
      {selected && (
        <img
          className="selected-icon"
          src="/assets/pdp/selected-fabric.svg"
          alt="add one less to cart"
        />
      )}

      <Imgix
        imgixParams={{ auto: 'compress,format' }}
        className="fabric-image-filter"
        sizes="
        (min-width: 992px) 100px,
        30vw"
        src={getImgixUrl(image)}
        htmlAttributes={{
          alt: name,
          loading: 'lazy'
        }}
      />
    </Wrapper>
  );
}

export default FabricItem;
